<template>
  <div class="edit-modal">
    <div class="form-group name-group">
      <label>{{ $t("remote_profile_name") }}</label>
      <el-input v-model="profileName" maxlength="30" class="name-input"></el-input>
      <button class="reset-button" @click="resetAll">
        <img :src="require(`@/assets/motions/reset.png`)" width="15" height="15"> {{ $t("motion_reset_all_parameters") }}
      </button>
    </div>

    <div v-for="channel in channels" :key="channel.key" class="slider-item" style="align-items: center;">
      <label>
        <input type="checkbox" v-model="channel.isAgreed" disabled/>
        {{ channelLabels[channel.key] }}
      </label>
      <template v-if="channel.isAgreed">
        <div class="parameter-row">
          <div class="inline-form-group">
            <label class="long-label">{{ $t("remote_profile_edit_axis_item_param_period") }}</label>
            <input v-model="formData[`textPer${channel.key}`]" class="custom-input">
          </div>
          <div class="inline-form-group">
            <label class="long-label">{{ $t("remote_profile_edit_axis_item_param_amp") }}</label>
            <input v-model="formData[`textAmp${channel.key}`]" class="custom-input">
          </div>
        </div>
      </template>
    </div>

    <div class="dialog-buttons">
      <button class="dialog-btn cancel-btn" @click="$emit('close')">{{ $t("layout_cancel") }}</button>
      <button class="dialog-btn confirm-btn" @click.prevent="saveChanges()">{{ $t("layout_confirm") }}</button>
    </div>
  </div>
</template>

<script>
import * as motionApi from "@/api/platform/motions";

class ChannelVo {
  constructor(name, period, amp) {
    this.name = name;
    this.period = period;
    this.amp = amp;
  }
}

class ChannelRangeVo {
  constructor(name, min, max) {
    this.name = name;
    this.min = min;
    this.max = max;
  }
}

class ProfileVo {
  constructor(pk, name, remark, type, channelList, channelRangeList) {
    this.pk = pk;
    this.name = name;
    this.remark = remark;
    this.type = type;
    this.channelList = channelList || [];
    this.channelRangeList = channelRangeList || [];
  }
}

export default {
  props: ['item'],
  data() {
    return {
      profileName: '',
      pk: this.item.pk,
      DEFAULT_VALUES: {
        textPerL0: 1500, textAmpL0: 60,
        textPerL1: 1500, textAmpL1: 60,
        textPerL2: 1500, textAmpL2: 60,
        textPerR0: 1500, textAmpR0: 60,
        textPerR1: 1500, textAmpR1: 60,
        textPerR2: 1500, textAmpR2: 60
      },
      channels: [
        { key: 'L0', isAgreed: false },
        { key: 'R1', isAgreed: false },
        { key: 'R2', isAgreed: false },
        { key: 'L1', isAgreed: false },
        { key: 'L2', isAgreed: false },
        { key: 'R0', isAgreed: false },
      ],
      formData: {
        textPerL0: 1500, textAmpL0: 60,
        textPerL1: 1500, textAmpL1: 60,
        textPerL2: 1500, textAmpL2: 60,
        textPerR0: 1500, textAmpR0: 60,
        textPerR1: 1500, textAmpR1: 60,
        textPerR2: 1500, textAmpR2: 60
      }
    };
  },
  computed: {
    channelLabels() {
      return {
        L0: this.$t('remote_control_mode_operation_L0_and_direction'),
        R1: this.$t('remote_control_mode_operation_R1_and_direction'),
        R2: this.$t('remote_control_mode_operation_R2_and_direction'),
        L1: this.$t('remote_control_mode_operation_L1_and_direction'),
        L2: this.$t('remote_control_mode_operation_L2_and_direction'),
        R0: this.$t('remote_control_mode_operation_R0_and_direction'),
      };
    }
  },
  methods: {
    async saveChanges() {
      try {
        const channelList = this.channels
          .filter(channel => channel.isAgreed)
          .map(channel => new ChannelVo(
            channel.key,
            this.formData[`textPer${channel.key}`],
            this.formData[`textAmp${channel.key}`]));

        const tempProfileVo = new ProfileVo(
          this.pk,
          this.profileName,
          "",
          "",
          channelList,
          []
        );

        const response = await motionApi.saveUserProfileInfo(tempProfileVo);
        this.$message({
          duration: 1500,
          message: this.$t('layout_operate_sucess'),
          type: 'success'
        });
        this.$emit('update', { ...this.item, name: this.profileName });
        this.$emit('close');
      } catch (error) {
        console.error('Save error:', error);
        this.$message({
          duration: 1500,
          message: this.$t('layout_operate_failed'),
          type: 'error'
        });
      }
    },
    findProfileInfoByPk(pk) {
      motionApi.findProfileInfoByPk(pk).then(res => {
        if (res.data && res.data.channelList) {
          this.channels.forEach(ch => ch.isAgreed = false);

          res.data.channelList.forEach(channel => {
            const found = this.channels.find(ch => ch.key === channel.name);
            if (found) {
              found.isAgreed = true;
              this.formData[`textPer${found.key}`] = channel.period;
              this.formData[`textAmp${found.key}`] = channel.amp;
            }
          });
        }
      });
    },
    resetAll() {
      this.formData = {...this.DEFAULT_VALUES};
      this.profileName = this.item.name || '';
    }
  },
  created() {
    this.profileName = this.item.name || '';
    this.findProfileInfoByPk(this.pk);
  }
};
</script>


<style scoped>
/* 保持原有样式不变 */
.edit-modal {
  width: 500px;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  font-size: 14px;
  color: #333;
}
.reset-button {
  flex: 1;
  padding: 12px 20px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  color: #8300F6;
  transition: all 0.3s;
}
.reset-button img {
  position: relative;
  top: 3px; /* 向下微调1像素 */
}
/* 新增样式 */
.name-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.name-input {
  width: 200px; /* 调整为你想要的宽度 */
}
.parameter-row {
  display: flex;
  gap: 40px;
  margin-top: 10px;
}

.inline-form-group {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

.long-label {
  width: auto;
  margin-right: 8px;
  min-width: 80px;
  font-size: 13px;
}

.custom-input {
  width: 80px;
  border: none;
  border-bottom: 1px solid #ccc;
  padding: 0 5px;
  outline: none;
  transition: border-color 0.3s;
}

.slider-item {
  padding: 15px;
  margin-bottom: 5px;
  background-color: #F4F1FAFF;
  border-radius: 2px;
}
.slider-item label {
  font-size: 14px;
  color: #333;
}
.dialog-buttons {
  display: flex;
  justify-content: center; /* 水平居中 */
  gap: 30px; /* 加大按钮之间间隔，你可以根据需要调整数值 */
  margin-top: 10px;
}

.dialog-btn {
  padding: 8px 35px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-btn {
  background-color: #F4F3F1;
  color: #AA81FF;
  border: 1px solid #AA81FF;
}

.cancel-btn:hover {
  background-color: #e0e0e0;
}

.confirm-btn {
  background-color: #AA81FF;
  color: white;
  border: none;
}

.confirm-btn:hover {
  background-color: #7200D6;
}
</style>



// WEBPACK FOOTER //
// src/pages/tcode/motions/edit.vue